import { useMediaQuery } from '@/hooks/useMediaQuery';

import type { InputSize } from '@/components/primitives/Input';

// Tailwind's `xl`, where AuthLayout puts the brand panel beside the card.
const SPLIT_QUERY = '(min-width: 1280px)';

/** The design's inputs are 44px tall beside the brand panel and 32px in the phone layout. */
export function useAuthInputSize(): InputSize {
  return useMediaQuery(SPLIT_QUERY) ? 'l' : 'm';
}
